import React, {createContext, useContext, useEffect, useState} from "react";
import {hasSubscriptionApi} from "../accountV2/subscription/api";
import {
  getCurrentAuthentication,
  isCustomer,
} from "../v2/getCurrentAuthentication";

interface SubscriptionInfoContext {
  hasSubscription: boolean;
}

const CustomerSubscriptionInfoContext = createContext<SubscriptionInfoContext>({
  hasSubscription: false,
});

export const SubscriptionInfoProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const [hasSubscription, setHasSubscription] = useState<boolean>(false);

  useEffect(() => {
    if (isCustomer(getCurrentAuthentication())) {
      (async () => {
        setHasSubscription(await hasSubscriptionApi());
      })();
    }
  }, []);

  return (
    <CustomerSubscriptionInfoContext.Provider value={{hasSubscription}}>
      {children}
    </CustomerSubscriptionInfoContext.Provider>
  );
};

export const useCustomerSubscriptionInfo = (): SubscriptionInfoContext => {
  return useContext<SubscriptionInfoContext>(CustomerSubscriptionInfoContext);
};
